import styled from "styled-components";

export const SliderInputContainer = styled.div``;

export const InputNumbers = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
